import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NumberOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, InputNumber, Popover, Row, Space } from "antd";
import { EExtendsMergeStrategy, ServiceTemplateField, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { Trans } from "@devowl-wp/react-frontend";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
/**
 * Form field for the execute priority of a service template.
 * This will be shown in a popover when hovering over the priority field.
 * @returns The form field.
 */ function FormFieldServiceTemplateExecutePriority() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(Popover, {
        placement: "bottomRight",
        overlayStyle: {
            maxWidth: 500
        },
        forceRender: true,
        content: /*#__PURE__*/ _jsxs(Space, {
            direction: "vertical",
            size: "small",
            children: [
                /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        children: /*#__PURE__*/ _jsx("b", {
                            children: t("Priority of script execution")
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsxs(Col, {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                                children: ({ getFieldValue })=>{
                                    const extended = getFieldValue(TemplateMetaDataField.Extends);
                                    return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                                        extendsFieldName: ServiceTemplateField.ExecutePriority,
                                        disableStrategies: getDisableStrategies(false, [
                                            EExtendsMergeStrategy.Clear
                                        ]),
                                        onKeepContent: extended && /*#__PURE__*/ _jsxs(Space.Compact, {
                                            block: true,
                                            style: {
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Input, {
                                                    value: t("Priority"),
                                                    readOnly: true,
                                                    tabIndex: -1,
                                                    className: `${process.env.ANTD_PREFIX}-input-compact-label`
                                                }),
                                                /*#__PURE__*/ _jsx(InputNumber, {
                                                    disabled: true,
                                                    value: extended[ServiceTemplateField.ExecutePriority],
                                                    style: {
                                                        flex: 1,
                                                        minWidth: 0,
                                                        width: "100%"
                                                    }
                                                })
                                            ]
                                        }),
                                        children: /*#__PURE__*/ _jsxs(Space.Compact, {
                                            block: true,
                                            style: {
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Input, {
                                                    value: t("Priority"),
                                                    readOnly: true,
                                                    tabIndex: -1,
                                                    className: `${process.env.ANTD_PREFIX}-input-compact-label`
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Item, {
                                                    name: ServiceTemplateField.ExecutePriority,
                                                    rules: [
                                                        {
                                                            type: "number",
                                                            min: 0,
                                                            max: 99,
                                                            message: t("Priority must be between 0 and 99")
                                                        }
                                                    ],
                                                    noStyle: true,
                                                    style: {
                                                        margin: 0,
                                                        flex: 1,
                                                        minWidth: 0
                                                    },
                                                    children: /*#__PURE__*/ _jsx(InputNumber, {
                                                        min: 0,
                                                        max: 99,
                                                        style: {
                                                            width: "100%"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    });
                                }
                            }),
                            " "
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        children: /*#__PURE__*/ _jsxs(Trans, {
                            children: [
                                "Scripts executed on opt-in or on opt-out can have the property",
                                " ",
                                /*#__PURE__*/ _jsx("code", {
                                    children: "unique-write-name"
                                }),
                                ". If multiple scripts have the same name, only one will be executed to avoid multiple executions. If scripts with the same name are executed in different services, the one with the lowest priority is executed (defines the execution order). Changing the priority is relevant, for example, if you create two services for tracking with and without cookies (on different legal bases) for the same analysis tool."
                            ]
                        })
                    })
                })
            ]
        }),
        trigger: "hover",
        children: /*#__PURE__*/ _jsx(Button, {
            type: "link",
            icon: /*#__PURE__*/ _jsx(NumberOutlined, {}),
            children: getFieldNameTranslated(ServiceTemplateField.ExecutePriority, t)
        })
    });
}
export { FormFieldServiceTemplateExecutePriority };
